// extracted by mini-css-extract-plugin
export var root = "container-module--root--de12f";